import {Zone} from '../address/zone';

export class InterestZone {
  interestZoneId: number;
  buyerId: number;
  zoneId: number;
  zone: Zone;
  status: string;
}
